<template lang="pug">
  .service-container
    .service-container__header.service-container__header__bg2
      .service-container__title {{ $t('广告运营') }}

      .service-container__desc {{ $t('专业成熟的SEM诊断，安心交给我们托管。') }}
      .service-container__desc {{ $t('经验丰富的广告投放团队，无论信息流还是KOL，享受一站式省心服务。') }}
      .service-container__tab__bg
        .service-container__tab
          .tab__title(
            @click="activeIndex = 0"
          )
            span {{ $t('广告投放服务') }}
            .tab__arrow(v-show="activeIndex === 0")
          .tab__title(
            @click="activeIndex = 1"
          )
            span {{ $t('SEM诊断及托管') }}
            .tab__arrow(v-show="activeIndex === 1")
    ad-service(v-if="activeIndex === 0")
    SEM(v-else)
    mobile-contact
</template>

<script>
import AdService from './components/AdService'
import SEM from './components/SEM'
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    AdService,
    SEM,
    MobileContact
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  watch: {
    '$route': {
      handler (nv, ov) {
        if (nv && nv.query.activeIndex && ((ov && nv.query.activeIndex !== ov.query.activeIndex) || !ov)) {
          this.activeIndex = Number(this.$route.query.activeIndex)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
